// removed by extract-text-webpack-plugin
module.exports = {"btn":"s86jXbRM8DKR4uxSYXuu8","success":"_2_Fjx-KU_qx2fumNqYiYDL","danger":"_1WrpFSmOGQOgw7zAm56p-C","rounded":"CT4aFIF0mLLXD7Z1uVcs6","rounded-orange":"_3Vu-8zeXz3toB83HuPZg2-","light":"_1KGk7HhDFAeiprkhFYcW4l"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/molecules/ActionBtnIcon/style.css
// module id = 300
// module chunks = 37